export const fncFileDownLoadUtil = (fileName: any, data: any) => {
    const url = window.URL.createObjectURL(new Blob([data], {type: 'image/png'}));
    const downLoad = document.createElement('a');
    downLoad['href'] = url;
    downLoad['download'] = fileName;
    document.body.appendChild(downLoad);
    downLoad.click();
    window.URL.revokeObjectURL(url);
};

export const fncZipFileDownLoadUtil = (fileName: any, data: any) => {
    const url = window.URL.createObjectURL(new Blob([data], {type: 'application/octet-stream'}));
    const downLoad = document.createElement('a');
    downLoad['href'] = url;
    downLoad['download'] = fileName;
    document.body.appendChild(downLoad);
    downLoad.click();
    window.URL.revokeObjectURL(url);
};

export const formatBytes = (bytes: number) => {
    if (!Number.isFinite(bytes) || bytes === 0) return '0 B';
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const value = bytes / Math.pow(1024, i);
    return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${sizes[i]}`;
};
